import { VStack, Text, Box, Pressable } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import ImageViewer from "../../components/imageViewer";
import VideoPlayer from "../../components/player";

const NotificationCard = ({
  header = "",
  body = "",
  timeline = "",
  item = {},
  mt = 2,
  handleMarkAsReadNotification = () => {},
  handleMarkAsReadNotifications = () => {},
  notification = true,
}) => {
  return (
    <VStack space={1} mt={mt}>
      <Pressable
        onPress={() => {
          if (!item.status)
            handleMarkAsReadNotification(
              item.id,
              item.status,
              item.event_id,
              item.package_id,
              item.type,
              item?.mis
            );
        }}
      >
        <Text
          fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          color={COLORS.NOTIFICATION_HEADING_COLOR}
        >
          {header}
        </Text>
      </Pressable>
      <Pressable
        onPress={() => {
          handleMarkAsReadNotifications(
            item.id,
            item.status,
            item.event_id,
            item.package_id,
            item.type,
            item?.mis
          );
        }}
      >
        <Text
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          color={COLORS.NOTIFICATION_TEXT_COLOR}
        >
          {body}
        </Text>
      </Pressable>
      {item && item.image && item.image !== "" && (
        <Box
          onPress={(e) => {
            e.preventDefault();
          }}
        >
          <ImageViewer
            toolbar={false}
            path
            images={[{ file_name: item.image.file_name }]}
            notification={notification}
            showIndividualCheckboxes={false}
          />
        </Box>
      )}
      {item && item.video?.path && item.video.path !== "" && (
        <Text
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          color={COLORS.NOTIFICATION_TEXT_COLOR}
        >
          <VideoPlayer path={item.video.path} />
        </Text>
      )}
      <Text
        fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
        fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
        color={COLORS.NOTIFICATION_TIME_COLOR}
      >
        {timeline}
      </Text>
    </VStack>
  );
};

export default NotificationCard;
